/** @jsxImportSource @emotion/react */

import MUIAlert, { AlertProps } from '@mui/material/Alert'
import { FC } from 'react'
import * as classes from './styles'

export const customMessages = {
  usedQuestion: 'Some of the questions are used either in a Question bank or a Practice test or a Video quiz.',
}

type Props = {
  message: string
  customMessage?: keyof typeof customMessages
} & AlertProps

export const Alert: FC<Props> = ({ customMessage, message, ...props }) => (
  <MUIAlert css={classes.alert} {...props}>
    {customMessage && customMessages[customMessage] ? (
      //TODO: return <strong> part dynamicly
      <span>
        <strong>An error has occured!</strong> {customMessages[customMessage]}
      </span>
    ) : (
      message
    )}
  </MUIAlert>
)

//{customMessage ? <span>`${firstSentence[alertType]} cutomMessages[customMessage]`</span> || message : message}
